import { bootstrapApplication } from '@angular/platform-browser';
import { Settings } from 'luxon';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

Settings.defaultLocale = 'da-DK';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
